<template functional>
  <div class="errorBox">
    <h1>Something went wrong. Please try logging again.</h1>
    <p>
      Please
      <a :href="url">click</a> to redirect to login screen.
    </p>
  </div>
</template>

<script>
export default {
  functional: true,
  url: process.env.VUE_APP_API_FORGOT_URL
};
</script>

<style scoped>
.errorBox {
  text-align: center;
  margin-top: 30px;;
}
.errorBox p a {
  color: #293896 !important;
  text-decoration: underline;
  font-weight: 700;
  text-transform: uppercase;
}
</style>
